<template>
  <loading v-if="isLoading"></loading>
  <not-found v-else-if="!item"></not-found>
  <div v-else class="container-fluid o-card">
    <div class="row">
      <div class="es-xs-12 u-margin-bottom">
        <h4>
          {{ item.title }}
          <Button
            v-if="!creatingPdf"
            size="sm"
            variant="light-danger"
            @click="creatingPdf = true"
          >
            <i class="icofont-file-pdf"></i> {{ $t("common.printCalculation") }}
          </Button>
          <router-link
            v-if="!creatingPdf"
            :to="{ name: 'cycles-selection' }"
            class="u-display-inline-block u-margin-top-sm-down"
          >
            <Button block variant="primary" class="u-margin-left-small">
              {{ $t("cycles.selection2") }}
            </Button>
          </router-link>
          <div>
            <small>{{ $date.format(item.createdDate || new Date()) }}</small>
          </div>
        </h4>
        <hr />
      </div>
      <div
        class="es-xs-12"
        :class="{ 'es-sm-4': !creatingPdf, 'es-sm-6': creatingPdf }"
      >
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("vincCalculating.potDimensions") }}
          </h6>
          <BaseInput
            v-model="item.requestPotDiameter"
            :label="$t('vincCalculating.potDiameter')"
            block
            readonly
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            suffix="m"
            type="number"
            :placeholder="$t('vincCalculating.potDiameter')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestPotHeight"
            :label="$t('vincCalculating.potHeight')"
            block
            readonly
            suffix="m"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.potHeight')"
            mandotary
          ></BaseInput>
        </div>
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("vincCalculating.glassDimensions") }}
          </h6>
          <BaseInput
            v-model="item.requestCabinHeight"
            :label="$t('vincCalculating.cabinHeight')"
            block
            readonly
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            suffix="m"
            :placeholder="$t('vincCalculating.cabinHeight')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestFrontGlassHeight"
            :label="$t('vincCalculating.frontGlassHeight')"
            block
            readonly
            suffix="m"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.frontGlassHeight')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestSideGlassHeight"
            :label="$t('vincCalculating.sideGlassHeight')"
            block
            suffix="m"
            readonly
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.sideGlassHeight')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestMetalWidth"
            :label="$t('vincCalculating.metalWidth')"
            block
            suffix="m"
            readonly
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.metalWidth')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestWallThickness"
            :label="$t('vincCalculating.wallThickness')"
            block
            suffix="mm"
            readonly
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.wallThickness')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestInsulationThickness"
            :label="$t('vincCalculating.insulationThickness')"
            block
            readonly
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            suffix="mm"
            :placeholder="$t('vincCalculating.insulationThickness')"
            mandotary
          ></BaseInput>
        </div>
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("vincCalculating.insulationDimensions") }}
          </h6>
          <BaseInput
            v-model="item.requestOutdoorTemperature"
            :label="$t('vincCalculating.outdoorTemperature')"
            block
            suffix="°C"
            readonly
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.outdoorTemperature')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestCabinTemperature"
            :label="$t('vincCalculating.cabinTemperature')"
            block
            suffix="°C"
            readonly
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.cabinTemperature')"
            mandotary
          ></BaseInput>
        </div>
      </div>
      <div
        class="es-xs-12"
        :class="{ 'es-sm-4': !creatingPdf, 'es-sm-6': creatingPdf }"
      >
        <div class="u-margin-bottom">
          <img
            :src="require(`@/assets/images/${$i18n.locale}/kabin-pota.png`)"
            width="100%"
            alt="kabin pota"
          />
        </div>
        <div id="result">
          <BaseInput
            :label="$t('vincCalculating.totalGlasses')"
            v-model="item.totalGlasses"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            block
            readonly
            disabled
            :size="creatingPdf ? 'sm' : 'xs'"
          ></BaseInput>
          <BaseInput
            :label="$t('vincCalculating.totalWalls')"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            v-model="item.totalWalls"
            block
            readonly
            disabled
            :size="creatingPdf ? 'sm' : 'xs'"
          ></BaseInput>
          <BaseInput
            :label="$t('vincCalculating.cabinTotalThermalLoad')"
            v-model="item.cabinTotalThermalLoad"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            block
            readonly
            suffix="kW"
            disabled
            :size="creatingPdf ? 'sm' : 'xs'"
          ></BaseInput>
        </div>
      </div>
      <div
        class="es-xs-12"
        :class="{
          'es-sm-4': !creatingPdf,
          'es-sm-12 u-margin-top': creatingPdf,
        }"
      >
        <div class="u-background-color-white o-card__padding-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("vincCalculating.automaticValues") }}
          </h6>
          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaKabinYatayUzaklik"
                :label="$t('vincCalculating.potaKabinYatayUzaklik')"
                block
                readonly
                disabled
                suffix="m"
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="10"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaKabinYukseklik"
                :label="$t('vincCalculating.potaKabinYukseklik')"
                block
                readonly
                disabled
                suffix="m"
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="15"
              ></BaseInput>
            </div>
          </div>

          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaYuzeyiSicakligi"
                :label="$t('vincCalculating.potaYuzeyiSicakligi')"
                block
                readonly
                disabled
                suffix="°C"
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="1473.15"
              >
              </BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaYuzeyiYaymaOrani"
                block
                readonly
                disabled
                :size="creatingPdf ? 'sm' : 'xs'"
                :label="$t('vincCalculating.yalitimliAlanOrani')"
                :value="0.9"
                suffix="°C"
              ></BaseInput>
            </div>
          </div>
          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaYanYuzeySicakligi"
                :label="$t('vincCalculating.potaYanYuzeySicakligi')"
                block
                readonly
                disabled
                suffix="°C"
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="973.15"
              >
              </BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaYanYuzeyYaymaOrani"
                block
                readonly
                disabled
                :size="creatingPdf ? 'sm' : 'xs'"
                :label="$t('vincCalculating.yalitimliAlanOrani')"
                :value="0.9"
                suffix="°C"
              ></BaseInput>
            </div>
          </div>
          <BaseInput
            v-model="automaticValues.yalitimliAlanOrani"
            :label="$t('vincCalculating.yalitimliAlanOrani2')"
            block
            readonly
            disabled
            :size="creatingPdf ? 'sm' : 'xs'"
            :value="0.8"
          ></BaseInput>

          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.disOrtamTasinimKatsayisi"
                :label="$t('vincCalculating.disOrtamTasinimKatsayisi')"
                block
                readonly
                disabled
                suffix="W/m².K"
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="30"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.kabinOrtamiTasinimKatsayisi"
                :label="$t('vincCalculating.kabinOrtamiTasinimKatsayisi')"
                block
                readonly
                disabled
                suffix="W/m².K"
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="25"
              ></BaseInput>
            </div>
          </div>
          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.duvarYaymaOrani"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                :label="
                  $t('vincCalculating.duvarYaymaOrani') +
                  ' / ' +
                  $t('vincCalculating.duvarGecirmeOrani')
                "
                block
                readonly
                disabled
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="0.8"
              >
              </BaseInput>
            </div>
            <div class="es-xs-12 es-md-2">
              <BaseInput
                v-model="automaticValues.duvarGecirmeOrani"
                block
                readonly
                disabled
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="0"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-md-2">
              <BaseInput
                v-model="automaticValues.duvarYaymaOrani"
                block
                readonly
                disabled
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="0.8"
              >
              </BaseInput>
            </div>
            <div class="es-xs-12 es-md-2">
              <BaseInput
                v-model="automaticValues.duvarGecirmeOrani"
                block
                readonly
                disabled
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="0"
              ></BaseInput>
            </div>
          </div>

          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.metalSacIsiIletimKatsayisi"
                :label="$t('vincCalculating.metalSacIsiIletimKatsayisi')"
                block
                readonly
                disabled
                suffix="W/m.K"
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="54"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.tasYunu"
                :label="$t('vincCalculating.tasYunu')"
                block
                readonly
                disabled
                suffix="W/m.K"
                :size="creatingPdf ? 'sm' : 'xs'"
                :value="0.042"
              ></BaseInput>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ExportPdf v-if="creatingPdf" @pdfCreated="creatingPdf = false" />
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import Loading from "../../Base/Loading/Loading.vue";
import NotFound from "../../Base/NotFound.vue";
import html2pdf from "html2pdf.js";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Button from "@/components/Base/Button.vue";
import ExportPdf from "./ExportPdf.vue";
export default {
  components: { Loading, NotFound, BaseInput, Button, ExportPdf },
  data() {
    return {
      cycleId: null,
      isLoading: true,
      cycle: null,
      creatingPdf: false,
      automaticValues: {
        potaKabinYatayUzaklik: 10,
        potaKabinYukseklik: 15,
        potaYuzeyiSicakligi: 1473.15,
        potaYuzeyiYaymaOrani: 0.8,
        potaYanYuzeySicakligi: 973.15,
        potaYanYuzeyYaymaOrani: 0.9,
        yalitimliAlanOrani: 0.8,
        disOrtamTasinimKatsayisi: 30,
        kabinOrtamiTasinimKatsayisi: 25,
        duvarYaymaOrani: 0.8,
        duvarGecirmeOrani: 0,
        metalSacIsiIletimKatsayisi: 54,
        tasYunu: 0.042,
      },
      item: {
        requestPotDiameter: 5,
        requestPotHeight: 4,
        requestFrontGlassHeight: 4,
        requestSideGlassHeight: 4,
        requestMetalWidth: 4,
        requestOutdoorTemperature: 4,
        requestCabinTemperature: 4,
        requestWallThickness: 4,
        requestInsulationThickness: 4,
        requestCabinHeight: 4,
        totalGlasses: -0.104,
        totalWalls: -15.398,
        cabinTotalThermalLoad: -15.502,
      },
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    result: {
      type: Object,
      required: true,
    },
    autoPrint: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setForm() {
      this.item = {
        title: this.title || this.$t("vincCalculating.mainTitle"),
        requestPotDiameter: this.form.potDiameter,
        requestPotHeight: this.form.potHeight,
        requestFrontGlassHeight: this.form.frontGlassHeight,
        requestSideGlassHeight: this.form.sideGlassHeight,
        requestMetalWidth: this.form.metalWidth,
        requestOutdoorTemperature: this.form.outdoorTemperature,
        requestCabinTemperature: this.form.cabinTemperature,
        requestWallThickness: this.form.wallThickness,
        requestInsulationThickness: this.form.insulationThickness,
        requestCabinHeight: this.form.cabinHeight,
        totalGlasses: this.result.totalGlasses,
        totalWalls: this.result.totalWalls,
        cabinTotalThermalLoad: this.result.cabinTotalThermalLoad,
      };
      this.isLoading = false;
      this.createPdf();
    },
    async getItem() {
      if (this.autoPrint) return this.setForm();
      this.isLoading = true;
      const response = await Requests.CraneHVACC.GetById({
        params: {
          id: this.$route.params.id,
        },
      });
      if (response.message === "OK") {
        this.item = response.data;
      }
      this.isLoading = false;
    },
    async createPdfBlob() {
      const element = document.getElementById("vinc-calculating-detail");
      const opt = {
        margin: [25, 1, 40, 1],
        filename: this.item.title + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      const footerImg = "/pdf-footer.png";
      const headerImg = "/pdf-header.png";
      //const footerLogo = ;
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.addImage(
              footerImg,
              "png",
              10,
              pdf.internal.pageSize.getHeight() - 30,
              pdf.internal.pageSize.getWidth() - 20,
              30
            );
            pdf.addImage(
              headerImg,
              "png",
              10,
              0,
              pdf.internal.pageSize.getWidth() - 20,
              25
            );
            // pdf.addImage(
            //   footerLogo,
            //   "png",
            //   0,
            //   0,
            //   pdf.internal.pageSize.getWidth(),
            //   0.3
            // );
          }
          window.open(pdf.output("bloburl"), "_blank");
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: false,
          });
          this.creatingPdf = false;
          this.$emit("pdfCreated");
        });
      return "";
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: "application/pdf" });
    },
    async createPdf() {
      this.creatingPdf = true;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.creatingPdf"),
        duration: 20 * 60 * 1000,
      });
      setTimeout(async () => {
        await this.createPdfBlob();
      }, 500);
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>

<style scoped>
page {
  background: white;
  display: block;
  margin: 0 auto;
  position: relative;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}

.page_header {
  position: running(header);
  width: 100%;
}

.page_footer {
  position: running(footer);
  width: 100%;
}

.pdf-content {
  padding: 20px;
}
</style>
